<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="Array.isArray(purchases)">
            <button class="btn btn-primary mb-2" v-if="purchases.length > 5" @click="showModalItemDelivery(0, 0, 1)"><i class="icon-plus3 mr-2"></i>Skapa ny beställning</button>
            <div
                v-for="(purchase, p_index) in purchases"
                :key="'p-' + p_index"
                class="card mb-2" style="border-left-width: 10px;"
                :class="[ 'border-left-' + (purchase.Typ === 1
                ? (purchase.PurchaseStatusID !== null && purchase.PurchaseStatusID < 50
                    ? purchase.PurchaseStatusBackgroundClass.substring(purchase.PurchaseStatusBackgroundClass.indexOf('-') + 1)
                    : ((purchase.Antal <= 0 || purchase.PurchaseStatusID === 255) ? 'danger' : 'primary'))
                : (purchase.DerivedRowID ? 'success' : 'purple')) ]"
            >
                <div class="card-body py-2">
                    <div class="row">
                        <div class="col-auto flex-grow-1">
                            <div class="row">
                                <div class="col-auto flex-grow-1" style="max-width: 225px;">
                                    <div>
                                        <div v-if="purchase.ProdPurchaseID" class="font-weight-bold">
                                            <router-link :to="{ name: 'suppliers.purchase', params: { id: purchase.ProdPurchaseID } }">SHT{{ String(purchase.ProdPurchaseID).padStart(6, '0') }}</router-link>
                                        </div>
                                        <div>
                                            <span v-if="purchase.Typ === 1 && purchase.PurchaseStatusID !== null && purchase.PurchaseStatusID < 50" class="badge"
                                                  :class="[ 'badge-' + purchase.PurchaseStatusBackgroundClass.substring(purchase.PurchaseStatusBackgroundClass.indexOf('-') + 1) ]">{{ purchase.PurchaseStatusName }}</span>
                                            <span v-else-if="purchase.Typ === 1 && (purchase.Antal <= 0 || purchase.PurchaseStatusID === 255)" class="badge badge-danger">Avbeställd</span>
                                            <span v-else-if="purchase.Typ === 1" class="badge badge-primary">Beställd</span>
                                            <span v-else-if="purchase.Typ === 3 && purchase.DerivedRowID" class="badge badge-success">Levererad</span>
                                            <span v-else-if="purchase.Typ === 3" class="badge badge-purple">Manuell inlev</span>
                                            <span v-if="purchase.Typ === 3 && purchase.DerivedRowID && purchase.Antal !== purchase.DerivedAntal" class="ml-1 badge badge-warning">
                                                <i class="icon-warning mr-1" style="font-size: 10px;"></i>Avvikelse
                                            </span>
                                        </div>
                                        <div v-if="purchase.ExtOrderID">Ext: {{ purchase.ExtOrderID }}</div>
                                    </div>
                                </div>
                                <div class="col-auto flex-grow-1">
                                    <div class="row">
                                        <div class="col-xl-4">
                                            <div v-if="purchase.Typ === 3"><span class="font-weight-bold">Beställt antal: </span>{{ (purchase.DerivedRowID ? purchase.DerivedAntal : '-') }}</div>
                                            <div v-else-if="purchase.Typ === 1"><span class="font-weight-bold">Beställt antal: </span>{{ purchase.Antal }}</div>
                                            <div v-if="purchase.Typ === 3"><span class="font-weight-bold">Levererat antal: </span>{{ purchase.Antal }}</div>
                                        </div>
                                        <div class="col-xl-4">
                                            <div><span class="font-weight-bold">Beställd av: </span><span v-if="purchase.OrderedByName">{{ purchase.OrderedByName }}</span></div>
                                            <div><span class="font-weight-bold">Skapad: </span>{{ purchase.CreatedTS ? formatDateTime(purchase.CreatedTS).substring(0, 16) : ''}}</div>
                                        </div>
                                        <div class="col-xl-4">
                                            <div><span class="font-weight-bold">Kvitterad av: </span><span v-if="purchase.Typ === 3 && purchase.CreatedByName">{{ purchase.CreatedByName }}</span></div>
                                            <div v-if="purchase.Typ === 3 && purchase.DerivedRowID">
                                                <span class="font-weight-bold">Leverans: </span>{{ purchase.DerivedEffectiveTS ? formatDateTime(purchase.DerivedEffectiveTS).substring(0, 16) : '' }}
                                            </div>
                                            <div v-else-if="purchase.Typ === 3"><span class="font-weight-bold">Leverans: </span>{{ purchase.EffectiveTS ? formatDateTime(purchase.EffectiveTS).substring(0, 16) : '' }}</div>
                                            <div v-else><span class="font-weight-bold">Förväntad leverans: </span>{{ purchase.EffectiveTS ? formatDateTime(purchase.EffectiveTS).substring(0, 16) : '' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto d-flex justify-content-end" style="width: 260px;">
                            <div>
                                <button
                                    v-if="purchase.Typ === 1 && purchase.Antal > 0 && purchase.PurchaseStatusID !== 255"
                                    class="btn btn-success mr-2"
                                    @click="showModalItemDelivery(0, purchase.RowID, 3)"
                                    :disabled="purchase.ProdPurchaseID > 0 && purchase.PurchaseStatusID < 50"
                                >
                                    <i class="icon-truck mr-2"></i>Inleverans
                                </button>
                                <button class="btn btn-light" @click="showModalItemDelivery(purchase.RowID, 0, purchase.Typ)"><i class="icon-pencil3 mr-2"></i>Redigera</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button class="btn btn-primary" @click="showModalItemDelivery(0, 0, 1)"><i class="icon-plus3 mr-2"></i>Skapa ny beställning</button>

            <b-modal id="modal-edit-prod-lager" @hidden="row_id = null; derived_row_id = null;" size="xl" hide-footer :title="(type === 3 ? 'Inleverans' : 'Beställningsunderlag')">
                <prod-lager-editor :id="row_id" :derived-id="derived_row_id" :prod-id="id" include @saved="prodLagerSaved"></prod-lager-editor>
            </b-modal>
        </div>
        <div v-else class="text-danger">Kunde ej hämta data...</div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { formatDateTime } from '@services/Helpers';
import ProdLagerEditor from '@app/pages/suppliers/partials/ProdLagerEditor';

export default {
    name: 'ProductEditPurchases',
    components: {
        ProdLagerEditor,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy: true,
        purchases: null,
        row_id: null,
        derived_row_id: null,
        type: 1,
    }),
    created() {
        this.getPurchases();
    },
    methods: {
        formatDateTime,
        async getPurchases() {
            await apiClient.get('/vue/suppliers/purchases/items?sort_by_column=RowID&sort_by_order=DESC&per_page=1000&is_deprecated=0&type[]=1&type[]=3&prod_id=' + this.id)
                .then((response) => {
                    if (response.data.data) {
                        this.purchases = response.data.data;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        showModalItemDelivery(rowId, derivedRowID, type) {
            this.row_id = rowId;
            this.derived_row_id = derivedRowID;
            this.type = type;

            this.$bvModal.show('modal-edit-prod-lager');
        },
        prodLagerSaved() {
            this.getPurchases();
            this.$bvModal.hide('modal-edit-prod-lager');
        },
    },
};

</script>
